module.exports = __webpack_public_path__ + "ee6f78600f699e8bb2db7a7bfb9b564d.svg";